export default __webpack_public_path__ + "static/media/A5_12.3fcc8f3d.mp3";